import KeenSlider from 'keen-slider';

let realtyGallerySliders = [];

// initialize realty gallery slider
export function initRealtyGallery(){
	let galleryImagesEls = document.querySelectorAll('.realty__gallery-slider');

	realtyGallerySliders.forEach(slider => slider.destroy());

	// initialize sliders
	galleryImagesEls.forEach(galleryImagesEl => {
		let sliderEl = galleryImagesEl.querySelector('.keen-slider');
		let buttonPrevEl = galleryImagesEl.querySelector('.swiper-button-prev');
		let buttonNextEl = galleryImagesEl.querySelector('.swiper-button-next');

		let slider = new KeenSlider(sliderEl, {
			slides: {
				perView: 1
			},
			loop: true,
			created() {
				window.lazyObserver.observe();
			}
		});

		buttonPrevEl.onclick = () => slider.prev();
		buttonNextEl.onclick = () => slider.next();

		realtyGallerySliders.push(slider);
	});
}

initRealtyGallery();